export const DEFAULT_PRICE_PLACEHOLDER = 'Введите цену';
export const PRICE_VALUE_FIELD = 'value';
export const PRICE_OPTIONS_FIELD = 'options';

export enum EPriceErrorMessages {
  Max = 'Цена не может быть более 2,1 млрд',
  GteLte = 'Цена "до" не может быть меньше цены "от"',
  GteRequired = 'Введите цену "от"',
  LteRequired = 'Введите цену "до"',
  Required = 'Укажите цену',
}
